/*
 * modal / help, delete
 */
export function initHelpModal() {
    let $tarButton;

    /**
     * ヘルプモーダル開く
     */
    $(document).on('click', '[class*="s-help--"]', function() {
        $tarButton = $(this);
        // クリックされた要素が class="s-help--xxx" の場合、対象モーダルの class は "s-modal--xxx" である
        let modalName = $tarButton.attr('class').match(/s-help--(\w+)/)?.[1];
        let $target = $('.s-modal--' + modalName);

        let $focus = $target.find('.s-modal_focus');
        $target.addClass('is-show').removeAttr('aria-hidden');
        $('.s-modal_bg').addClass('is-show');
        $('html').addClass('is-locked');
        $('.s-maincontent').attr('aria-hidden', true).attr('inert', true);
        setTimeout(() => {
            $focus.trigger('focus');
        }, 100);

        if ($('.s-help_lock').length > 0) {
            let $lockedElement = $('.s-help_lock');
            let $lockedElementWrap = $('.s-help_lock_wrap');
            let lockedElementOffsetTop = $lockedElement.offset().top;
            let lockedElementMargin = parseInt($lockedElement.css('margin-top'));
            let lockedWrapOffsetTop = $lockedElementWrap.offset().top;
            let windowTop = $(window).scrollTop();

            // stickyの上からの距離 - stickyのmargin-top - 親要素（position:relative;）の上からの距離 + スクロール距離
            let positionTop = lockedElementOffsetTop - lockedElementMargin - lockedWrapOffsetTop + windowTop;
            $lockedElement.css('top', positionTop + 'px');
        }
    });

    /**
     * ヘルプモーダル閉じる
     */
    $(document).on('click', '.s-modal_bg, .s-modal_close', function() {
        let $closeFocus = $tarButton;
        
        $('.s-help_balloon.is-show').removeClass('is-show').attr('aria-hidden', true);
        $('.s-modal_bg').removeClass('is-show');
        $('html').removeClass('is-locked');
        $('.s-maincontent').removeAttr('aria-hidden').removeAttr('inert');
        setTimeout(() => {
            $closeFocus.trigger('focus');
        }, 100);

        if ($('.s-help_lock').length > 0) {
            let $lockedElement = $('.s-help_lock');
            $lockedElement.css('top', 0 + 'px');
        }
    });

    /**
     * 削除と同時にモーダルを閉じる
     */
    $(document).on('click', '.s-delete', function() {
        $('.s-help_balloon.is-show').removeClass('is-show').attr('aria-hidden', true);
        $('.s-modal_bg').removeClass('is-show');
        $('html').removeClass('is-locked');
        $('.s-maincontent').removeAttr('aria-hidden').removeAttr('inert');
    });

}
